import React from "react";
import { Typography } from "antd";
import DashboardLayout from "../components/DashboardLayout";
import { Bar } from "@ant-design/charts"; // Importing the Bar chart component

const { Title } = Typography;

const Statistics: React.FC = () => {
  // Data for the bar chart
  const data = [
    { category: "Project Alpha", value: 30 },
    { category: "Project Beta", value: 70 },
    { category: "Project Gamma", value: 50 },
  ];

  // Configuration for the bar chart
  const config = {
    data,
    xField: "value",
    yField: "category",
    color: "#1890ff", // Ant Design primary color
    barWidthRatio: 0.8,
    xAxis: {
      label: {
        formatter: (v: string) => `${v}%`, // Display percentages
      },
    },
    tooltip: {
      showMarkers: false,
    },
    interactions: [
      {
        type: "active-region",
      },
    ],
  };

  return (
    <DashboardLayout>
      <div style={{ padding: "1rem" }}>
        <Title level={3}>Statistics</Title>
        <p>This is the Statistics page where you can view project performance metrics.</p>
        {/* Render the Bar chart */}
        <Bar {...config} />
      </div>
    </DashboardLayout>
  );
};

export default Statistics;
